import React, { useEffect, useRef, useState } from "react";
import {Container, Modal, Row, Col, Button} from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import TimePicker from "rc-time-picker";

import '../../assets/Styles/ActivateTripCSS/ActivateTripCSS.css';
import "rc-time-picker/assets/index.css";

import DateTimeControl from '../Controls/DateTimePicker.js';
import APICom from "../../utils/helpers/APICom.js";
import DateTimeUtils from "../../utils/DateTimeUtility.js";

const ActivateTrip = (props) => {

  const requestTimeRef = useRef();
  const requestApptRef = useRef();

  const { loginData }  = useSelector((store) => store.login);
  const { ASCSSettingData }  = useSelector((store) => store.combinedata);

  const[showActivateTripDialog, setShowActivateTripDialog] = useState(props.showActivateDialog);
  const[activateTripObj, setActivateTripObj] = useState({ iATSPID : '-1', ServiceID: '-1', ConfirmationNo:'', OriginalTime:moment(), OriginalAppt: moment(),
  RequestDate:'', RequestTime:'', RequestAppt: '', iAssignedVehicleID: -1 });
  const [originalDate, setOriginalDate] = useState({disable:true,id:"txtTripOriginalDate",className:"txtTripOriginalDate", styles:{width:"160px", marginLeft:"10px", height:"28px", fontSize: "small"}});
  const [requestedDate, setRequestedDate] = useState({id:"txtTripRequestDate",className:"txtTripRequestDate", styles:{width:"160px", marginLeft:"10px", height:"28px", fontSize: "small"}});
  const [nb10, setNb10] = useState(600);
  const [requestedTime, setRequestedTime] = useState('');
  const [requestedAppt, setRequestedAppt] = useState('');
  const [showActivationAlert, setShowActivationAlert] = useState(false);
  const [activateAlert, setActivateAlert] = useState({alertTitle: '', alertMsg:''});

  const [TableHeaders, setTableHeaders] = useState(["Confirmation#","Orig. DateTime","Orig. Appt. Time", "Req DateTime", "Req Appt. Time"]);
  const [showActivationMultiple, setShowActivationMultiple] = useState(false);
  const [tripsInfo, setTripsInfo] = useState({});
  const [TripActivationChanges, setTripActivationChanges] = useState([]);
  const [failAlert, setFailAlert] = useState(false);
  const calendarRestriction = useRef(null);

  useEffect(() => {
    const allEqual = arr=> arr.every(v=> v===arr[0]);
    if(props.GridRowData === null || props.GridRowData.length <=0)
    {
      setActivateAlert({...activateAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to activate.'});
      setShowActivationAlert(true);
    }
    else if(props.GridRowData.length > 1)
    {
      // setActivateAlert({...activateAlert, alertTitle: 'Multiple trips selected', alertMsg:'Please select one trip to activate.'});
      // setShowActivationAlert(true);
      let tripActivationInfo = [];
      let dict = {};
      setTripsInfo(props.GridRowData);
      let tripsStatus = [];
      for(let l = 0; l < props.GridRowData.length; l++)
      {
        tripsStatus.push(props.GridRowData[l].TripRequestStatus.toUpperCase());
      }
      
      if(allEqual(tripsStatus) && tripsStatus[0] === "CANCELLED" || tripsStatus[0] === "NOSHOW")
      {
        for(let i = 0; i < props.GridRowData.length; i++)
        {
          dict = {};
          // Parse the input time string (.match(/(\d+):(\d+)(\w{2})/))
          const standardTime = (props.GridRowData[i].PickupDateTime.split(" ")[parseInt(props.GridRowData[i].PickupDateTime.split(" ").length-1)]);
          const militaryTime = DateTimeUtils.toMilitaryTime(standardTime);
          
          // Extract hours, minutes, and period (AM/PM)
          // let hours = parseInt(time[1], 10);
          // let minutes = parseInt(time[2], 10);
          // let period = time[3].toUpperCase();
  
          // Convert to military time
          // if (period === 'PM' && hours !== 12) {
          //   hours += 12;
          // } else if (period === 'AM' && hours === 12) {
          //   hours = 0;
          // }
          // let militaryTime = (parseInt(hours)<10?'0'+hours:hours)+':'+(parseInt(minutes)<10?'0'+minutes:minutes);
          let requestDateTemp = props.GridRowData[i].PickupDateTime.split(" ")[0];
          requestDateTemp = requestDateTemp.split("/");
          const correctYearFormat = (requestDateTemp[2]+"-"+(parseInt(requestDateTemp[0]) < 10 ? "0" + parseInt(requestDateTemp[0]) : requestDateTemp[0]) + "-" +
            (parseInt(requestDateTemp[1]) < 10 ? "0" + parseInt(requestDateTemp[1]):requestDateTemp[1])
          );
          dict["requestedDate"] = correctYearFormat;
          dict["requestedTime"] = militaryTime;
          dict["requestedApptTime"] = props.GridRowData[i].ApptTime;
          tripActivationInfo.push(dict);
        }
        let todayDt = new Date(),
        month = todayDt.getMonth()+1,
        day = todayDt.getDate(),
        year = todayDt.getFullYear();
        if(month < 10)
          month = '0'+month.toString();
        if(day < 10)
          day = '0' + day.toString();
  
        let minDate = year + '-' + month + '-' + day;
        calendarRestriction.current = minDate;
        setTripActivationChanges(tripActivationInfo);
        setShowActivationMultiple(true);
        setShowActivateTripDialog(true);
      }
      else
      {
        setActivateAlert({...activateAlert, alertTitle: 'Trip Selection Alert', alertMsg:'Please select a trip with the status CANCELLED or NOSHOW only.'});
        setShowActivationAlert(true);
      }
      
    }
    else
    {
      if(props.GridRowData[0].TripRequestStatus.toUpperCase() === "CANCELLED" || props.GridRowData[0].TripRequestStatus.toUpperCase() === "NOSHOW")
      {
        if(ASCSSettingData !== null && ASCSSettingData !== undefined)
        {
            if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
              const jsonArray = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
              jsonArray.forEach(item => {
                if(item.SubTitle === "Nb10"){
                  setNb10(item.value);
                  return false;
                }
              });
            }
        }

        let OrginalDateTime = moment(props.GridRowData[0].PickupDateTime, 'MM/DD/YYYY hh:mma');
        let RequestTimePlusNb10 = moment(props.GridRowData[0].PickupDateTime, 'MM/DD/YYYY hh:mma').add(nb10, 'seconds');
        let _NewApptDateTime = '';
        if(props.GridRowData[0].ApptTime !== "")
        {
          let _OrigApptDateTime = moment(props.GridRowData[0].PickupDateTime.split(' ')[0] + ' ' + props.GridRowData[0].ApptTime, 'MM/DD/YYYY hh:mma').add(nb10, 'seconds');
          _NewApptDateTime = _OrigApptDateTime;
        }
        setActivateTripObj((prevState) => ({...prevState, iATSPID: props.GridRowData[0].iSRATSPID, ServiceID: props.GridRowData[0].ServiceID,
          ConfirmationNo: props.GridRowData[0].ConfirmationNo, 
          OriginalTime:moment(OrginalDateTime, 'hh:mm A'), 
          OriginalAppt: (props.GridRowData[0].ApptTime === "") ? moment() : moment(props.GridRowData[0].ApptTime, 'hh:mm A'),
          RequestDate: moment(RequestTimePlusNb10, 'MM/DD/YYYY').format('MM/DD/YYYY'),
          RequestTime: moment(RequestTimePlusNb10, 'hh:mm A'), 
          RequestAppt: (props.GridRowData[0].ApptTime === "") ? moment() : moment(_NewApptDateTime, 'hh:mm A'),
          iAssignedVehicleID: props.GridRowData[0].iAssignedVehicleID
        }));
        setOriginalDate((prevStateDate) => ({...prevStateDate, initialDate: OrginalDateTime.toDate()}));
        setRequestedDate((prevStateDate) => ({...prevStateDate, initialDate: RequestTimePlusNb10.toDate()}));
        setRequestedTime((prevStateTime) => ({...prevStateTime, requestedTime: RequestTimePlusNb10.format('hh:mm A')}));
        setRequestedAppt((prevStateAppt) => ({...prevStateAppt, requestedAppt: (props.GridRowData[0].ApptTime === "") ? '' : _NewApptDateTime.format('hh:mm A')}));
        setShowActivateTripDialog(true);
      }
      else
      {
        setActivateAlert({...activateAlert, alertTitle: 'Trip Selection Alert', alertMsg:'Please select a trip with the status CANCELLED or NOSHOW only.'});
        setShowActivationAlert(true);
      }
        
  }
  }, []);

  const handleRequestDateChange = (date) => {
    let activateDate = moment(date, 'YYYY/MM/DD');
    let activateDateFormatted = activateDate.format("MM/DD/YYYY");
    setActivateTripObj((prevState) => ({...prevState, RequestDate: activateDateFormatted }));
  };

  const handleRequestTimeChange = (Time) => {
    if(Time !== null)
    {
      let activateTime = moment(Time, 'YYYY/MM/DD hh:mm A');
      let activateTimeFormatted = activateTime.format("hh:mm A");
      setRequestedTime((prevState) => ({...prevState, requestedTime: activateTimeFormatted }));
      setActivateTripObj((prevState) => ({...prevState, RequestTime: activateTime}));
    }
    else{
      setRequestedTime((prevState) => ({...prevState, requestedTime: '' }));
      setActivateTripObj((prevState) => ({...prevState, RequestTime: null}));
    }
  };

  const handleRequestApptChange = (Appt) => {
    if(Appt !== null)
    {
      let activateAppt = moment(Appt, 'YYYY/MM/DD hh:mm A');
      let activateApptFormatted = activateAppt.format("hh:mm A");
      setRequestedAppt((prevState) => ({...prevState, requestedAppt: activateApptFormatted }));
      setActivateTripObj((prevState) => ({...prevState, RequestAppt: activateAppt}));
    }
    else
    {
      setRequestedAppt((prevState) => ({...prevState, requestedAppt: '' }));
      setActivateTripObj((prevState) => ({...prevState, RequestAppt: null}));
    }
  };

  const handleOkActivateTripDialog = async() => {
    try{
      if(props.GridRowData.length > 1)
      {
        let confirmationFlag = false;
        for(let i in TripActivationChanges)
        {
          // Parse the input time string
          let time = props.GridRowData[i].PickupDateTime.split(" ")[parseInt(props.GridRowData[i].PickupDateTime.split(" ").length-1)].match(/(\d+):(\d+)(\w{2})/);
          // Extract hours, minutes, and period (AM/PM)
          let hours = parseInt(time[1], 10);
          let minutes = parseInt(time[2], 10);
          let period = time[3].toUpperCase();
          // Convert to military time
          if (period === 'PM' && hours !== 12) {
            hours += 12;
          } else if (period === 'AM' && hours === 12) {
            hours = 0;
          }

          let militaryTime = (parseInt(hours)<10?'0'+hours:hours)+':'+(parseInt(minutes)<10?'0'+minutes:minutes);
          
          if(parseInt(TripActivationChanges[i].requestedTime.split(":")[0]) < parseInt(militaryTime.split(":")[0]))
          {
            setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:<p className="user-select-none fw-normal m-0">
              {"Please select a requested time in future for trip#: "}<b>{props.GridRowData[i].ConfirmationNo}</b><br/>{"Original Req Time: "}<b>
                {props.GridRowData[i].PickupDateTime.split(" ")[(props.GridRowData[i].PickupDateTime.split(" ").length-1)]}</b></p>});
            setFailAlert(true);
            setShowActivationAlert(true);
            break;
          }
          else
          {
            let data = {
              "ServiceID": tripsInfo[i].ServiceID, "iATSPID" : tripsInfo[i].iSRATSPID, "iUserID": loginData.iUserID, 
              "activationDateTime" : (TripActivationChanges[i].requestedDate+" "+TripActivationChanges[i].requestedTime), 
              "activationApptDateTime" : TripActivationChanges[i].requestedApptTime, "iAppID": "26"
            };
            let response = await APICom.fetchData("", "TripActions/PerformActivate", "post", { "Content-Type": "application/json" }, data, null);
            if(parseInt(response.data.rowcount) <= 0)
            {
              setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Trip Activation Failed.'});
              setShowActivationAlert(true);
              confirmationFlag = false;
              break;
            }
            else
            {
              confirmationFlag = true;
            }
          }
        }
        
        if(confirmationFlag)
        {
          setActivateAlert({...activateAlert, alertTitle: 'Action Successful', alertMsg:'Trips activated successfully.'});
          setShowActivationAlert(true);
          return false;
        }
      }
      else
      {
        let ApptDT = (requestedAppt.requestedAppt === "")? "": activateTripObj.RequestDate + " " + requestedAppt.requestedAppt;
        if(ApptDT !== "")
        {
          let ReqDT = activateTripObj.RequestDate + " " + requestedTime.requestedTime;
          if(ReqDT !== '' && moment(ReqDT, 'MM/DD/YYYY hh:mma') > moment(ApptDT, 'MM/DD/YYYY hh:mma'))
          {
            setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Schedule time cannot be greater than appointment time.'});
            setShowActivationAlert(true);
            return false;
          }
          else if(ReqDT !== '' && moment(ReqDT, 'MM/DD/YYYY hh:mma').isSame(moment(ApptDT, 'MM/DD/YYYY hh:mma')))
          {
            setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Schedule time cannot be same as appointment time.'});
            setShowActivationAlert(true);
            return false;
          }
        }
        let actObj = {"ServiceID": "-1", "iATSPID" : "-1", "iUserID": "-1", "activationDateTime" : '', "activationApptDateTime" : ''}
        actObj["ServiceID"] = activateTripObj.ServiceID;
        actObj["iATSPID"] = activateTripObj.iATSPID;
        actObj["iUserID"] = loginData.iUserID;
        actObj["activationDateTime"] = activateTripObj.RequestDate + " " + requestedTime.requestedTime;
        actObj["activationApptDateTime"] = (requestedAppt.requestedAppt === "")? "": activateTripObj.RequestDate + " " + requestedAppt.requestedAppt;
        actObj["iAppID"] = "26";
        let response = await APICom.fetchData("", "TripActions/PerformActivate", "post", { "Content-Type": "application/json" }, actObj, null);
        let result = response.data;
        if(Number(result.rowcount) > 0)
        {
          setActivateAlert({...activateAlert, alertTitle: 'Action Successful', alertMsg:'Trip activated successfully.'});
          setShowActivationAlert(true);
          return false;
        }
        else
        {
          setActivateAlert({...activateAlert, alertTitle: 'Action Failed', alertMsg:'Trip activation failed.'});
          setShowActivationAlert(true);
          return false;
        }
      }

    }
    catch(err){console.log(err);}
    
  };

  const handleCloseActivateTripDialog = () => {
    setShowActivateTripDialog(false);
    UnMountActivateTripComponent();
  };

  const handleAlertModalClose = () => {
    setShowActivationAlert(false);
    if(!failAlert)
    {
      UnMountActivateTripComponent();
    }
  };

  const UnMountActivateTripComponent = () => {
    if(props.showActivateDialog)
    {
      props.setShowActivateDialog(false);
    }
  };

  const handleFilteringConfirmNum = (e)=>{
    try{
      let elements = document.getElementsByClassName('TripsActivationList');
      
      for(var k = 0; k < elements.length; k++)
      {
          if(!elements[k].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
          {
            elements[k].style.display = "none";
          }
          else
          {
            elements[k].style.display = "table-row";
          }
      }
    }
    catch(err){console.log(err);}
  };

  const handleSelectionChange = (index, key, selection)=>{
    try{
      setTripActivationChanges(prevState=>{
        const newState = {...prevState};
        newState[index][key] = selection;
        return newState;
      });
    }
    catch(err){console.log(err);}
  };

  return(
    <>
      
      {showActivateTripDialog && props.GridRowData.length > 0 && props.GridRowData[0].TripRequestStatus.toUpperCase() === "CANCELLED" || props.GridRowData[0].TripRequestStatus.toUpperCase() === "NOSHOW"? <Modal size='lg' show={showActivateTripDialog} centered onHide={()=>setShowActivateTripDialog(false)} aria-labelledby="contained-modal-title-vcenter" keyboard={true} backdrop="static" animation={true}>
        <Modal.Header className='activate_dialog_header_bgcolor' closeButton onClick={handleCloseActivateTripDialog}>
          <Modal.Title className="activate_dialog_title_color user-select-none" id="contained-modal-title-vcenter">
            Trip Activation
          </Modal.Title>
        </Modal.Header>
        {showActivationMultiple? 
          <Modal.Body className="grid-example">
            <Row className="overflow-auto" style={{height:"150px"}}>
              <Col className="justify-content-center">
                <table className="border border-dark" >
                  <thead>
                      <tr className="text-center text-nowrap">
                          {TableHeaders.map((head, headID) =>{
                              if(head === "Confirmation#")
                              {
                                return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="" onKeyUp={handleFilteringConfirmNum} className="d-block w-100 text-center"/></th>;
                              }
                              else
                              {
                                return <th className="border border-dark p-1 user-select-none" key={headID}>{head}</th>;
                              }
                          })}
                      </tr>
                  </thead>
                  <tbody>
                    {tripsInfo.map((item, index)=>(
                        <tr key={index} className="text-center TripsActivationList">
                          <td className="border border-dark user-select-none">{item.ConfirmationNo}</td>
                          <td className="border border-dark user-select-none p-1 text-nowrap">{item.PickupDateTime}</td>
                          <td value={item.ApptTime} className="border border-dark user-select-none">{item.ApptTime === null || item.ApptTime === "" ? "N/A":item.ApptTime}</td>
                          <td className="border border-dark"><input min={calendarRestriction.current} type="date" className="text-center d-inline-flex my-1"  onChange={(e)=>handleSelectionChange(index, "requestedDate", e.target.value)} value={TripActivationChanges[index].requestedDate}/>
                            <input type="time" className="d-inline-flex text-center my-1" value={TripActivationChanges[index].requestedTime} onChange={(e)=>handleSelectionChange(index, "requestedTime", e.target.value)}/>
                          </td>
                          <td className="border border-dark user-select-none"><input className="text-center" value={TripActivationChanges[index].requestedApptTime} type="time" onChange={(e)=>handleSelectionChange(index, "requestedApptTime", e.target.value)}/></td>
                        </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Modal.Body>
        
        :<Modal.Body className="grid-example">
          Are you sure to activate Trip# <b>{activateTripObj.ConfirmationNo}</b> for the request date & time?
          <Container>
          <Row>
            <Col xs={6} md={3}>
                &nbsp;
              </Col>
            <Col xs={6} md={3}>
            &nbsp;
              </Col>
              <Col xs={6} md={2} style={{fontWeight: "bold"}}>
              {/* &nbsp; */}
              Req. Time
              </Col>
              <Col xs={6} md={2} style={{fontWeight: "bold"}}>
              {/* &nbsp; */}
              Appt. Time
              </Col>
            </Row>
            <Row>
              <Col xs={6} md={3} style={{fontWeight: "bold"}}>
                  Original DateTime
              </Col>
              <Col xs={6} md={3}>
                <DateTimeControl options={originalDate} SelectionChangeCallback={handleRequestDateChange} />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.OriginalTime} disabled showSecond={false} allowEmpty format={"hh:mm A"} use12Hours  />
              </Col>
              <Col xs={6} md={2}>
                <TimePicker value={activateTripObj.OriginalAppt} disabled showSecond={false} allowEmpty format={"hh:mm A"} use12Hours  />
              </Col>
            </Row>

            <Row>
              <Col xs={6} md={3} style={{fontWeight: "bold"}}>
                Request DateTime
              </Col>
              <Col xs={6} md={3}>
                  <DateTimeControl options={requestedDate} SelectionChangeCallback={handleRequestDateChange}  />
              </Col>
              <Col xs={6} md={2}>
                  <TimePicker value={activateTripObj.RequestTime} onChange={handleRequestTimeChange} showSecond={false} allowEmpty format={"hh:mm A"} use12Hours ref={requestTimeRef} clearIcon={false} />
              </Col>
              <Col xs={6} md={2}>
                  <TimePicker value={activateTripObj.RequestAppt} onChange={handleRequestApptChange} showSecond={false} allowEmpty format={"hh:mm A"} use12Hours ref={requestApptRef} />
              </Col>
            </Row>
          </Container>
        </Modal.Body>}
        <Modal.Footer>
          <Button variant="dark" onClick={handleOkActivateTripDialog}>Yes</Button>
          <Button variant="secondary" onClick={handleCloseActivateTripDialog}>No</Button>
        </Modal.Footer>
      </Modal>:""}

      { showActivationAlert && <Modal centered show={showActivationAlert} onHide={handleAlertModalClose} backdrop="static" animation={true} >
                            <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                              <Modal.Title className='activate_dialog_title_color user-select-none'>
                                {activateAlert.alertTitle}
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="user-select-none">
                              <b>{activateAlert.alertMsg}</b>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={handleAlertModalClose}>
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>}
    </>
  );
};

export default ActivateTrip;